import {
    faCircleMinus,
    faCirclePlus,
} from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Decimal from "decimal.js";
import { isNumber } from "lodash";
import { useRef } from "react";
import { useTranslation } from "react-i18next";

export interface Props {
    value?: number;
    onChange: (value: number) => void;
    sufix?: string;
    counterskip?: number;
    minValue: number;
    maxValue: number;
    labelVale: string;
    styles?: React.CSSProperties;
    inputStyles?: React.CSSProperties;
    disabled?: boolean;
    testIdPrefix?: string;
}

export function Counter({
    value,
    onChange,
    sufix,
    counterskip,
    minValue,
    inputStyles,
    maxValue,
    labelVale,
    disabled,
    styles,
    testIdPrefix,
}: Props) {
    const { t } = useTranslation();
    const textInput = useRef<HTMLInputElement>(null);
    function onIncrement() {
        if (!disabled) {
            const step = counterskip || 1;

            if (isNumber(value)) {
                const newValue = new Decimal(value).plus(step);

                if (newValue.greaterThan(maxValue)) {
                    onChange(new Decimal(maxValue).toNumber());
                } else {
                    onChange(newValue.toNumber());
                }
            } else {
                onChange(minValue);
            }
        }
    }

    function onDecrement() {
        if (!disabled) {
            const step = counterskip || 1;

            if (isNumber(value)) {
                const newValue = new Decimal(value).minus(step);

                if (newValue.lessThan(minValue)) {
                    onChange(new Decimal(minValue).toNumber());
                } else {
                    onChange(newValue.toNumber());
                }
            } else {
                onChange(minValue);
            }
        }
    }

    return (
        <div
            className="d-flex justify-content-between align-items-center target-widget-counter"
            style={{ cursor: "default", ...(styles || {}) }}
            onClick={() => textInput.current?.focus()}
            onKeyDown={() => textInput.current?.focus()}
            role="button"
            tabIndex={0}
        >
            <FontAwesomeIcon
                icon={faCircleMinus}
                fontSize={16}
                onClick={onDecrement}
                color="var(--color-primary)"
                {...(testIdPrefix && {
                    "data-testid": `${testIdPrefix}-minus`,
                })}
            />

            <div className="d-flex justify-content-start align-items-center hide-number-input-arrows">
                <label htmlFor={labelVale} className="w-100">
                    <input
                        ref={textInput}
                        type="number"
                        className="pt-1 align-text-center font-medium text-dark no-border"
                        value={value ? value.toString() : ""}
                        onChange={(v) => onChange(parseFloat(v.target.value))}
                        max={maxValue}
                        min={minValue}
                        disabled={disabled}
                        maxLength={4}
                        style={{ width: "50px", ...(inputStyles || {}) }}
                        {...(testIdPrefix && {
                            "data-testid": `${testIdPrefix}-input`,
                        })}
                        onInput={(e) => {
                            const input = e.target as HTMLInputElement;
                            if (input.value.length > 5 && labelVale !== "ml") {
                                input.value = input.value.slice(0, 5);
                            }
                        }}
                    />
                </label>
                <span className="pt-1">{sufix ? t(sufix) : ""}</span>
            </div>

            <FontAwesomeIcon
                icon={faCirclePlus}
                fontSize={16}
                onClick={onIncrement}
                color="var(--color-primary)"
                {...(testIdPrefix && { "data-testid": `${testIdPrefix}-plus` })}
            />
        </div>
    );
}
